/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

import { formatCoverageValue } from 'Utils';
import { comparisonTableStyle, ComparisonTableColumns } from './comparisonTableLayout';

import './index.css';


const TableCoverages = (props) => {
  const { coverages, assists, packages } = props;
  const [ otherCoverages, setOtherCoverages ] = useState(false);

  useEffect(() => {
    for (var i = 0; i < packages.length; i++) {
      if (packages[i].other_coverages.length > 0) {
        setOtherCoverages(true);
        break;
      }
    }
  }, []);

  const getCoveragePackageValue = (paquete, coverageId) => {
    const packageCoverage = paquete.coverages.find((coverage) => coverage.id === coverageId);
    if (!packageCoverage) return <FontAwesomeIcon icon={faXmark} style={{ color: 'red' }} />; // 'No cubre';

    const value = formatCoverageValue(packageCoverage.insured_value);
    return <div style={{ textAlign: 'center' }}>
      <FontAwesomeIcon icon={faCheck} style={{ color: 'rgb(0, 221, 10)' }} />
      <div>
        {!!value ? <p style={{ margin: 0, fontSize: '14px' }}>Límite: <span style={{ fontWeight: 'bold' }}>{value}</span></p> : ''}
        {packageCoverage.deductible ? <p style={{ margin: 0, fontSize: '14px' }}>Deducible: <span style={{ fontWeight: 'bold' }}>{packageCoverage.deductible}</span></p> : ''}
      </div>
      {/* {value != true || packageCoverage.deductible ?
        <div>
          <span title="Límite">{value != true ? value : 'Si límite'}</span>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <span title="Deducible">{packageCoverage.deductible ? packageCoverage.deductible : 'Sin deducible'}</span>
        </div>
       : ''} */}
    </div>
  };

  const getAssistPackageValue = (paquete, assistId) => {
    const packageAssist = paquete.assists.find((coverage) => coverage.id === assistId);
    if (!packageAssist) return <FontAwesomeIcon icon={faXmark} style={{ color: 'red' }} />; // 'No cubre';

    const value = formatCoverageValue(packageAssist.insured_value);
    return <div style={{ textAlign: 'center' }}>
      <FontAwesomeIcon icon={faCheck} style={{ color: 'rgb(0, 221, 10)' }} />
      <div>
        {!!value ? <p style={{ margin: 0, fontSize: '14px' }}>Límite: <span style={{ fontWeight: 'bold' }}>{value}</span></p> : ''}
        {packageAssist.deductible ? <p style={{ margin: 0, fontSize: '14px' }}>Deducible: <span style={{ fontWeight: 'bold' }}>{packageAssist.deductible}</span></p> : ''}
      </div>
      {/* {value != true || packageAssist.deductible ?
        <div>
          <span title="Límite">{value != true ? value : 'Si límite'}</span>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <span title="Deducible">{packageAssist.deductible ? packageAssist.deductible : 'Sin deducible'}</span>
        </div>
       : ''} */}
    </div>
  };

  const otherCoverageTable = (paquete) => {
    const coverages = paquete.other_coverages;
    
    if (coverages.length > 0) {
      return <table className="c011619">
        <tbody>
          {coverages.map((coverage) => {
            const value = formatCoverageValue(coverage.insured_value);

            return <React.Fragment key={`${coverage.id}-${Math.random()}`}>
              <tr>
                <td key={`${coverage.id}-${paquete.id}-${Math.random()}`} className="c01419">
                  <span>
                    <div style={{ textAlign: 'center' }}>
                      <FontAwesomeIcon icon={faCheck} style={{ color: 'rgb(0, 221, 10)' }} />
                      <span style={{ fontWeight: 'bold', marginLeft: '10px'}}>{coverage.name}</span>
                      <div>
                        {!!value ? <p style={{ margin: 0, fontSize: '14px' }}>Límite: <span style={{ fontWeight: 'bold' }}>{value}</span></p> : ''}
                        {coverage.deductible ? <p style={{ margin: 0, fontSize: '14px' }}>Deducible: <span style={{ fontWeight: 'bold' }}>{coverage.deductible}</span></p> : ''}
                      </div>
                    </div>
                  </span>
                </td>
              </tr>
            </React.Fragment>
          })}
        </tbody>
      </table>;
    }
    
    return null;
  };

  return (
    <div>
      <table className="c011619" style={comparisonTableStyle(packages.length)}>
        <ComparisonTableColumns planCount={packages.length} packages={packages} />
        <tbody>
          <tr>
            <th className="c01396 c01397" colSpan={`${packages.length+parseInt(1)}`}>
              <p className="c01404 c01407">Coberturas</p>
            </th>
          </tr>
          {coverages.map((coverage) => (
            <React.Fragment key={`${coverage.id}-${Math.random()}`}>
              <tr className="c0194877">
                <td className="c01419">
                  <p className="c01404 c01407">{coverage.name}</p>
                </td>
                {packages.map((paquete) => (
                  <td key={`${coverage.id}-${paquete.id}-${Math.random()}`} className="c01419">
                    <div>
                      <div className="c01422">
                        <span>{getCoveragePackageValue(paquete, coverage.id)}</span>
                      </div>
                    </div>
                  </td>
                ))}
              </tr>
            </React.Fragment>
          ))}
          <tr>
            <th className="c01396 c01397" colSpan={`${packages.length+parseInt(1)}`}>
              <p className="c01404 c01407">Asistencias</p>
            </th>
          </tr>
          {assists.map((assist) => (
            <React.Fragment key={`${assist.id}-${Math.random()}`}>
              
              <tr className="c0194877">
                <td className="c01419">
                  <p className="c01404 c01407">{assist.name}</p>
                </td>
                {packages.map((paquete) => (
                  <td key={`${assist.id}-${paquete.id}-${Math.random()}`} className="c01419">
                    <div>
                      <div className="c01422">
                        <span>{getAssistPackageValue(paquete, assist.id)}</span>
                      </div>
                    </div>
                  </td>
                ))}
              </tr>
            </React.Fragment>
          ))}
          {otherCoverages ?
            <React.Fragment key={`other-packages-${Math.random()}`}>
              <tr>
                <th className="c01396 c01397" colSpan={`${packages.length+parseInt(1)}`}>
                  <p className="c01404 c01407">Otras coberturas</p>
                </th>
              </tr>
              <tr>
                <td className="c01419"></td>
                {packages.map((paquete) => (
                  <td key={`${paquete.id}-${Math.random()}`} className="c01419">
                    <div>
                      <div className="c01422">
                        <span>{otherCoverageTable(paquete)}</span>
                      </div>
                    </div>
                  </td>
                ))}
              </tr>
            </React.Fragment>
          : null}
        </tbody>
      </table>
    </div>
  );
};

TableCoverages.propTypes = {
  coverages: PropTypes.array.isRequired,
  assists: PropTypes.array.isRequired,
  packages: PropTypes.array.isRequired,
};

export default TableCoverages;
